<template>
  <div>
  <div class="page_footer">

    <div class="site_info">

      <div class="site_intro">
        <div class="si_top">
          U Vigor Health Medical Technology Co., Ltd
          <div>&nbsp;</div>
          <ul class="footer_ul">
            <li><a target="_blank" ><img src="../assets/image/contact/index_55.jpg"></a></li>
            <li><a target="_blank" ><img src="../assets/image/contact/index_57.jpg"></a></li>
            <li><a target="_blank" ><img src="../assets/image/contact/index_67.jpg"></a></li>
            <li><a target="_blank" ><img src="../assets/image/contact/index_69.jpg"></a></li>
          </ul>
        </div>

      </div>

      <div class="site_map">

        <div class="map_list">
          <el-row>
            <el-col :span="2">
              <span>&nbsp;</span>
              <a><i class="el-icon-phone" style="margin-right: 5px"></i></a>
              <a><i class="el-icon-message" style="margin-right: 5px"></i></a>
              <a><i class="el-icon-s-home" style="margin-right: 5px"></i></a>
              <a>&nbsp;</a>
              <a><i class="el-icon-location-outline" style="margin-right: 5px"></i></a>
              <a>&nbsp;</a>
            </el-col>
            <el-col :span="22">
              <span>GET IN TOUCH</span>
              <a>+86-193-5708-8711</a>
              <a>info@uvigorhealth.com</a>
              <a>http://www.uvigorhealth.com</a>
              <a>No. 4, Shanxian Road, </a>
              <a>Gongshu District, Hangzhou City,</a>
              <a>Zhejiang Province, China</a>
            </el-col>
          </el-row>
        </div>


        <div class="map_list2">
          <span>&nbsp;</span>
          <a class="map_list2-a-title"><router-link to="/products">Products</router-link></a>
          <a v-for="item in productCategorys" :key="item.productCategoryId">
            <router-link :to="{path:item.productCategoryRouter, query:{productCategoryId:item.productCategoryId}}">{{item.productCategoryName}}</router-link>
          </a>
        </div>

        <div class="map_list2">
          <span>&nbsp;</span>
          <a class="map_list2-a-title"><router-link to="/">Home</router-link></a>
          <a class="map_list2-a-title"><router-link to="/aboutUs">About us</router-link></a>
          <a class="map_list2-a-title"><router-link to="/news">News</router-link></a>
          <a class="map_list2-a-title"><router-link to="/service">Service</router-link></a>
          <a class="map_list2-a-title"><router-link to="/contactUs">Contact us</router-link></a>
        </div>

      </div>

    </div>



  </div>
    <div id="footer"> U Vigor Health Medical Technology Co., Ltd. All rights reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'abc',
  data() {
    return {
      productCategorys: []
    }
  },
  methods: {
    initCategorys() {
      let url = '/product/listCategory';
      this.getRequest(url).then(resp => {
        if (resp) {
          this.productCategorys = resp.data;
          if(this.productCategorys && this.productCategorys.length > 4){
            this.productCategorys = this.productCategorys.slice(0,4);
          }
        }
      });
    }
  },
  mounted() {
    this.initCategorys();
  },
}
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../assets/css/footer.css" scoped>
</style>
